var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H13M7 19V14M7 19H1.6C1.44087 19 1.28826 18.9368 1.17574 18.8243C1.06321 18.7117 1 18.5591 1 18.4V14.6C1 14.4409 1.06321 14.2883 1.17574 14.1757C1.28826 14.0632 1.44087 14 1.6 14H7M13 19V7M13 19H18.4C18.5591 19 18.7117 18.9368 18.8243 18.8243C18.9368 18.7117 19 18.5591 19 18.4V1.6C19 1.44087 18.9368 1.28826 18.8243 1.17574C18.7117 1.06321 18.5591 1 18.4 1H13.6C13.4409 1 13.2883 1.06321 13.1757 1.17574C13.0632 1.28826 13 1.44087 13 1.6V7M7 14V7.6C7 7.44087 7.06321 7.28826 7.17574 7.17574C7.28826 7.06321 7.44087 7 7.6 7H13",
    stroke: "#8B909A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.6e57002cade20a274d9fe217f795f05b.svg";
export { ForwardRef as ReactComponent };